import React, { InputHTMLAttributes, useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import { Switch } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import CircularProgress from '@material-ui/core/CircularProgress';
import { fetchSpidActive, invokeChangeSpidActive, } from "../api-client/client"
import Grid from "@material-ui/core/Grid";
import ErrorMessage from "../components/ErrorMessage";
import Collapse from "@material-ui/core/Collapse";

const SpidSwitchPage: React.FC = () => {
    const [spidActive, setSpidActive] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>();
    const [refreshOngoing, setRefreshOngoing] = useState<boolean>(true);
    const [initialized, setInitialized] = useState<boolean>(false);

    const handleSwitchChange = (checked: boolean) => {
        setRefreshOngoing(true);
        invokeChangeSpidActive(checked)
            .then(() => new Promise((res) => setTimeout(res, 300)))
            .then(() => {
                // @ts-ignore
                setSpidActive(!spidActive);
                setRefreshOngoing(false);
             })
            .catch(error => {
                setErrorMsg(error.message);
        });
    };

    useEffect(() => {
        let timerId: any
        fetchSpidActive().then(fetchedSpidActive => {
            setSpidActive(fetchedSpidActive.active)
            timerId = setTimeout(() => { setRefreshOngoing(false); }, 10);
            setInitialized(true);
        }).catch(error => {
            setErrorMsg(error.message);
        });
        return () => {
            clearTimeout(timerId)
        }
    }, [setSpidActive]);

    return (
        <Box mt={4}>
            <Paper>
                <Box p={3} pt={4}>
                    <Typography component="h2" variant="h5" color="primary" gutterBottom>
                        SPID Switch
                    </Typography>
                    <Typography variant={"body2"}>
                        You can use the switch on this page to toggle the status of SPID. Click to
                        toggle between active and inactive state.
                    </Typography>
                    <Box pt={2}>
                    { errorMsg ? <ErrorMessage message={errorMsg}/> : (
                        initialized ? (
                                <FormControlLabel
                                    data-testid={ "switch-container-spid" }
                                    control={ <Switch
                                        checked={ spidActive }
                                        color={ "primary" }
                                        disabled={ refreshOngoing }
                                        onChange={ (event, checked) => handleSwitchChange(checked) }
                                        inputProps={ { "data-testid": "switch-spid" } as InputHTMLAttributes<HTMLInputElement> }
                                    /> }
                                    label={
                                        <Collapse in={ !refreshOngoing } mountOnEnter={ true }>
                                            <Box fontStyle={ "italic" }><Typography
                                                variant={ "caption" }>{ spidActive ? "SPID active" : "SPID inactive" }</Typography></Box>
                                        </Collapse>
                                    }/>
                        ) : <Grid container justifyContent={ "center" }><CircularProgress/></Grid>) }
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default SpidSwitchPage;
